import React, { useEffect, useState } from "react";
import DefaultApiService from "../../../infrastructure/api/default";
import { Box, Grid, Typography } from "@mui/material";
import { Space } from "react-zoomable-ui";
import LoadingWrapper from "../shared/loading";
import CounterDetailDialog from "./CounterDetailDialog";

const SingleLineDiagram = ({ substationId }) => {
  const [diagramData, setDiagramData] = useState({});
  const [loading, setLoading] = useState(false);
  const [counterDetailDialog, setCounterDetailDialog] = useState({
    open: false,
    positionId: null,
  });

  useEffect(() => {
    getLineDiagramData(substationId);
  }, [substationId]);

  const getLineDiagramData = async (substationId) => {
    try {
      setLoading(true);
      const url = `GV/SingleLineDiagram/GetData`;
      const res = await DefaultApiService.getApi(url, {
        SubstationId: substationId,
      });
      setLoading(false);

      if (res.status === 404) {
        throw new Response("Not Found", { status: 404 });
      }
      setDiagramData(res.data);
    } catch (error) {
      setLoading(false);
    }
  };

  // Internal Trans
  const onRenderInternalTrans = (index) => (
    <Box className="internal-trans">
      {index % 2 === 0 ? (
        <>
          <Box className="internal-trans-right" />
          <Box className="internal-trans-left">
            <span className="horizontal-line line"></span>
            <div className="icon">
              <span className="circle-first"></span>
              <span className="circle-second"></span>
            </div>
            <div className="detail">ترانس داخلی و ارت</div>
          </Box>
        </>
      ) : (
        <>
          <Box className="internal-trans-right">
            <span className="horizontal-line line"></span>
            <div className="icon">
              <span className="circle-first"></span>
              <span className="circle-second"></span>
            </div>
            <div className="detail">ترانس داخلی و ارت</div>
          </Box>
          <Box className="internal-trans-left" />
        </>
      )}
    </Box>
  );

  // Main Trans
  const onRenderMainTrans = (trans) => (
    <Box className="main-trans">
      <Box className="icon">
        <span className="circle-first"></span>
        <span className="circle-second"></span>
      </Box>
      <Box className="detail">63/20 KV</Box>
      <Box className="title">{trans.transNumber}</Box>
    </Box>
  );

  // Feeder
  const onRenderFeeders = (feeders, index) => (
    <Box
      className="feeders-section"
      sx={{
        marginTop: index !== 0 ? "-20px" : "unset",
        marginLeft: index !== 0 ? "35px" : "unset",
      }}
    >
      {feeders && feeders.length > 0
        ? feeders.map((feeder) => (
            <Box className="feeder" key={feeder.counterSerial}>
              <span className="vertical-line line-before" />
              <Box
                className="counter-serial"
                onClick={() => onShowCounterDetail(feeder?.id)}
              >
                {feeder.counterSerial}
              </Box>

              {feeder.dgList.length > 0 ? (
                onRenderDGs(feeder, feeder.dgList)
              ) : (
                <Box className="arrow">
                  <span className="vertical-line line" />
                  <i className="icon" />
                  <Box className="title">{feeder.feederName}</Box>
                </Box>
              )}
              {onRenderExchanges(feeder.exchangeList)}
            </Box>
          ))
        : null}
    </Box>
  );

  const onRenderDGs = (feeder, dgs) =>
    dgs && dgs.length > 0
      ? dgs.map((dg, index) => (
          <Box key={index}>
            {dg.dgInjectionKind !== "Feeder" ? (
              <>
                <Box className="arrow up">
                  <i className="icon-up" />
                  <span className="vertical-line line" />
                  <Box className="title">{feeder.feederName}</Box>
                </Box>
                <Box className="dg-section feeder-injection">
                  <Box className="dg-icon">DG</Box>
                  <Box className="dg-detail">بزرگتر از 7 مگاوات</Box>
                  <Box className="dg-title">{dg.dgName}</Box>
                </Box>
              </>
            ) : (
              <>
                <Box className="arrow">
                  <span className="vertical-line line" />
                  <i className="icon" />
                  <Box className="title">{feeder.feederName}</Box>
                </Box>
                <Box className="dg-section bus-bar-injection">
                  <span className="horizontal-line line-top" />
                  <span className="vertical-line line-right" />
                  <Box
                    className="dg-counter-serial"
                    onClick={() => onShowCounterDetail(dg.id)}
                  >
                    {dg.counterSerial}
                  </Box>
                  <Box className="arrow-up">
                    <i className="icon" />
                    <span className="vertical-line line" />
                  </Box>
                  <Box className="dg-icon">DG</Box>
                  <Box className="dg-detail">کوچکتر از 7 مگاوات</Box>
                  <Box className="dg-title">{dg.dgName}</Box>
                </Box>
              </>
            )}
          </Box>
        ))
      : null;

  const onRenderExchanges = (exchanges) =>
    exchanges && exchanges.length > 0
      ? exchanges.map((exchange) => (
          <Box className="exchange-section" key={exchange.id}>
            <Box className="mof-container">
              <Box className="mof-detail ">MOF</Box>
              <Box className="mof-title ">M</Box>
            </Box>

            <Box className="mof-arrow-down">
              <span className="vertical-line line" />
              <i className="icon" />
            </Box>

            <Box
              className="exchange-counter-serial"
              onClick={() => onShowCounterDetail(exchange?.id)}
            >
              {exchange.counterSerial}
            </Box>

            <Box className="arrow-down">
              <span className="vertical-line line" />
              <i className="icon" />
            </Box>

            <Box className="exchange-title">{exchange.exchangeTitle}</Box>
          </Box>
        ))
      : null;

  // On Show Counter Detail
  const onShowCounterDetail = (positionId) => {
    setCounterDetailDialog({
      open: true,
      positionId,
    });
  };

  return (
    <Grid
      container
      item
      xs={12}
      md={12}
      className="single-line-diagram-wrapper"
    >
      <CounterDetailDialog
        open={counterDetailDialog.open}
        onClose={() => {
          setCounterDetailDialog({
            open: false,
            positionId: null,
          });
        }}
        positionId={counterDetailDialog.positionId}
      />

      <Grid item xs={12} md={12}>
        <Typography textAlign={"center"} variant="h6" fontWeight={"bold"}>
          مدار تک خطی سیستم ایستگاه 20 / 63 کیلوولت{" "}
          {diagramData?.substationName}
        </Typography>
      </Grid>

      <Grid item xs={12} md={12} className="zoom-wrapper">
        {loading ? (
          <LoadingWrapper />
        ) : (
          <Space className="zoom-space">
            <Box className="diagrams" sx={{ mt: 2 }}>
              {diagramData?.transList?.map((trans, index) => (
                <Box
                  className="diagram"
                  key={trans.id}
                  id={`diagram-${index + 1}`}
                >
                  <Box className="arrow-down">
                    <span className="vertical-line line" />
                    <i className="icon" />
                  </Box>

                  {/* electric-meter */}
                  <Box className="electric-meter">کنتور برق منطقه‌ای</Box>

                  {/* internal trans */}
                  {onRenderInternalTrans(index)}

                  {/* main trans */}
                  {onRenderMainTrans(trans)}

                  {/* trans serial number */}
                  <Box className="serial-number">
                    <span className="vertical-line before-line" />

                    <Box
                      className="counter-serial"
                      onClick={() => onShowCounterDetail(trans?.id)}
                    >
                      {trans?.counterSerial}
                    </Box>

                    <span className="vertical-line after-line" />
                  </Box>

                  {/* bus bar */}
                  <Box className="bus-bar">
                    <span className="horizontal-line line"></span>
                    {index !== 0 && <span className="riser"></span>}
                  </Box>

                  {/* feeder */}
                  {onRenderFeeders(trans.feederList, index)}
                </Box>
              ))}
            </Box>
          </Space>
        )}
      </Grid>
    </Grid>
  );
};

export default SingleLineDiagram;
